import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Key from '@mui/icons-material/Key';
import { Toolbar } from '../../components/ui/toolbar/toolbar.component';
import CustomModal from '../../components/ui/modal/modal.component';
import ClientPortalContactForm from '../../components/clientPortalContactForm/clientPortalContactForm.component';
import { PORTAL_CONTACTS_REFRESH_EVENT } from '../../consts';
import { Action } from '../../types/toolbar';
import { useHasPermission } from '../../contexts/auth';

export const ClientPortalAccessActions = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const [addOpened, setAddOpened] = useState(false);
  const canAdd = useHasPermission('portal.add_clientportalcontact');

  const actions: Action[] = [
    {
      id: 'grant-portal-access',
      icon: <Key />,
      label: t('Grant portal access'),
      onClick: () => setAddOpened(true),
      disabled: !canAdd,
    },
  ];

  return (
    <>
      <Toolbar actions={actions} />
      <CustomModal
        opened={addOpened}
        setOpened={setAddOpened}
        title={t('Grant portal access')}
        minWidth={480}
        content={
          <ClientPortalContactForm
            clientId={id ?? ''}
            onSuccess={() => {
              setAddOpened(false);
              window.dispatchEvent(new Event(PORTAL_CONTACTS_REFRESH_EVENT));
            }}
          />
        }
      />
    </>
  );
};
